module.exports = __webpack_public_path__ + "img/9.2e78e8a8.jpg";